<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'about_us.about_us' | translate}}</h1>
      <a [routerLink]="['/nosotros/sobre-nosotros']">
        <img src="../../../assets/img/icons/Seccion Nosotros/Icono-sobre-nosotros.png" alt="">
      </a>
      <a [routerLink]="['/nosotros/nuestro-equipo']">
        <img src="../../../assets/img/icons/Seccion Nosotros/icono-nuestro-equipo.png" alt="">
      </a>

    </div>
  </div>
</section>
